<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      menuLocation: state => state.graphicAspect.menuLocation
    }),
    dataTableHeight () {
      const { smAndDown, lgAndDown } = this.$vuetify.breakpoint
      const smallHeight = 42
      let mediumHeight = 57
      let largeHeight = 67
      if (this.menuLocation === 'toolbar') {
        mediumHeight = 69
        largeHeight = 77
      }
      if (smAndDown) return `${smallHeight}vh`
      if (lgAndDown) return `${mediumHeight}vh`
      return `${largeHeight}vh`
    }
  }
}
</script>
